export const responseBigQueryStorages = {
  data: {
    attributes: {
      path: '/ebs/ftpd/test-1640951289162-000001'
    },
    id: 972
  }
};